// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"InformationManagement--next-sr-only--2oRb_hq","widthFull":"InformationManagement--widthFull--smW5TNi","input":"InformationManagement--input--3yB8H3P"};